import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const PackingAppEndPoints = {
  CARTON_COUNT_INFO: 'CARTON_COUNT_INFO',
  PACKING_CONFIG: 'PACKING_CONFIG',
  CARTON_SELECTION_LISTING: 'CARTON_SELECTION_LISTING',
  CARTON_GROUP_DETAIL_LISTING: 'CARTON_GROUP_DETAIL_LISTING',
  START_CARTON: 'START_CARTON',
  COMPLETE_CARTON: 'COMPLETE_CARTON',
  AUTO_FILL_AND_COMPLETE_CARTONS: 'AUTO_FILL_AND_COMPLETE_CARTONS',
  SAVE_PACKS: 'SAVE_PACKS',
  CARTON_DETAIL_BY_ID: 'CARTON_DETAIL_BY_ID',
  TRANSACTION_LISTING: 'TRANSACTION_LISTING',
  TRANSACTION_CARTON_DETAIL: 'TRANSACTION_CARTON_DETAIL',
  TOTAL_WIP_QTY: 'TOTAL_WIP_QTY',
  BCTX_MAPPING_LIST: 'BCTX_MAPPING_LIST',
  SNP_CARTON_CREATION_DETAILS: 'SNP_CARTON_CREATION_DETAILS',
  SNP_CARTONS_BY_BCTX: 'SNP_CARTONS_BY_BCTX',
  SNP_CREATE_CARTON: 'SNP_CREATE_CARTON',
  SNP_SAVE_CARTON: 'SNP_SAVE_CARTON',
  SNP_COMPLETE_CARTON: 'SNP_COMPLETE_CARTON',
  SNP_PACKING_CONFIG: 'SNP_PACKING_CONFIG',
  SNP_BCTX_TRANSACTIONS: 'SNP_BCTX_TRANSACTIONS',
  SNP_CARTON_TRANSACTIONS: 'SNP_CARTON_TRANSACTIONS',
  CARTON_COUNT_INFO_SNP: 'CARTON_COUNT_INFO_SNP',
  GET_CARTON_SNP: 'GET_CARTON_SNP',
};

type TPackingAppEndPoints = typeof PackingAppEndPoints;
type TPackingAppEndPointsTypes = keyof TPackingAppEndPoints;

@Injectable({ providedIn: 'root' })
export class PackingInputAppEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TPackingAppEndPoints = {
    CARTON_COUNT_INFO: '',
    PACKING_CONFIG: '',
    CARTON_SELECTION_LISTING: '',
    CARTON_GROUP_DETAIL_LISTING: '',
    START_CARTON: '',
    COMPLETE_CARTON: '',
    AUTO_FILL_AND_COMPLETE_CARTONS: '',
    SAVE_PACKS: '',
    CARTON_DETAIL_BY_ID: '',
    TRANSACTION_LISTING: '',
    TRANSACTION_CARTON_DETAIL: '',
    TOTAL_WIP_QTY: '',
    BCTX_MAPPING_LIST: '',
    SNP_CARTON_CREATION_DETAILS: '',
    SNP_CARTONS_BY_BCTX: '',
    SNP_CREATE_CARTON: '',
    SNP_SAVE_CARTON: '',
    SNP_COMPLETE_CARTON: '',
    SNP_PACKING_CONFIG: '',
    SNP_BCTX_TRANSACTIONS: '',
    SNP_CARTON_TRANSACTIONS: '',
    CARTON_COUNT_INFO_SNP: '',
    GET_CARTON_SNP: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;
    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.CARTON_COUNT_INFO =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/carton/count';
    this.env_vars.PACKING_CONFIG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/config/';
    this.env_vars.CARTON_SELECTION_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/listing/selection';
    this.env_vars.CARTON_GROUP_DETAIL_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/listing/groupDetails';
    this.env_vars.START_CARTON =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/startCartonsPacking';
    this.env_vars.COMPLETE_CARTON =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/completeCartonPacking';
    this.env_vars.AUTO_FILL_AND_COMPLETE_CARTONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/autoFillAndCompleteCartons';
    this.env_vars.SAVE_PACKS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/savePackDetails';
    this.env_vars.CARTON_DETAIL_BY_ID =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/getCartonDetails';
    this.env_vars.TRANSACTION_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/listing/bctxTransactions';
    this.env_vars.TRANSACTION_CARTON_DETAIL =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/listing/cartonTransactions';
    this.env_vars.TOTAL_WIP_QTY =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/totalWip';
    this.env_vars.BCTX_MAPPING_LIST =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/packing/po-split/list-of-bctx-mapping';
    this.env_vars.SNP_CARTON_CREATION_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/fetchCartonCreationDetails';
    this.env_vars.SNP_CARTONS_BY_BCTX =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/fetchCartonDetailsByBctx';
    this.env_vars.SNP_CREATE_CARTON =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/createNewCarton';
    this.env_vars.SNP_SAVE_CARTON =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/saveCartonDetails';
    this.env_vars.SNP_COMPLETE_CARTON =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/completeCartonDetails';
    this.env_vars.SNP_PACKING_CONFIG =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/config/';
    this.env_vars.SNP_BCTX_TRANSACTIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/listing/bctxTransactions';
    this.env_vars.SNP_CARTON_TRANSACTIONS =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/listing/cartonTransactions';
    this.env_vars.CARTON_COUNT_INFO_SNP =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/carton/count';
    this.env_vars.GET_CARTON_SNP =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.packing_services + '/api/v1/scanAndPack/getCartonDetails';
  }

  public getEnvVar(arg: TPackingAppEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
